import { render, staticRenderFns } from "./ModuleProductDetailSharing.vue?vue&type=template&id=5cbee64f&scoped=true&lang=html"
import script from "./ModuleProductDetailSharing.vue?vue&type=script&lang=js"
export * from "./ModuleProductDetailSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbee64f",
  null
  
)

export default component.exports